"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAPreOrderAdditionalItemDetailsComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSMMAPreOrderAdditionalItemDetailsComponent {
    constructor(modalService) {
        this.modalService = modalService;
        this.accessoryItemId = new core_1.EventEmitter();
        this.cancelAccessoryEmitter = new core_1.EventEmitter();
        this.cancelEstoreAccessoryEmitter = new core_1.EventEmitter();
    }
    openCancelAccessoryModal(itemId, name) {
        this.modalError = null;
        this.lineItemId = itemId;
        this.accessoryName = name;
        this.modelRef = this.modalService.open(this.modalCancelAccessory, { centered: true });
    }
    cancelEstoreAccessory() {
        this.cancelEstoreAccessoryEmitter.emit(true);
    }
    cancelAccessory() {
        this.accessoryItemId.emit(this.lineItemId);
        this.cancelAccessoryEmitter.emit(true);
    }
    ngOnDestroy() {
        this.modelRef = this.modalService.dismissAll();
    }
}
exports.CSMMAPreOrderAdditionalItemDetailsComponent = CSMMAPreOrderAdditionalItemDetailsComponent;
//# sourceMappingURL=preorder-additional-item-details.js.map